<template>
  <TransitionGroup name="error-indicator">
    <div
      v-for="indicator in activeIndicators"
      :key="indicator.id"
      class="error-pill bg-red-600 rounded-full px-4 py-2 shadow-lg fixed z-[9999] pointer-events-none"
      :class="[
        indicator.position === 'top' ? 'top-20' : 'bottom-20',
        'left-1/2 transform -translate-x-1/2'
      ]"
      :style="{ animationDelay: `${indicator.timestamp % 1000}ms` }"
    >
      <div class="flex items-center space-x-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-white flex-shrink-0">
    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
</svg>

        <span class="text-white text-sm font-medium whitespace-nowrap">
          {{ indicator.position === 'top' ? 'Errors above' : 'Errors below' }}
        </span>
      </div>
    </div>
  </TransitionGroup>
</template>

<script setup lang="ts">
import { useErrorIndicatorStore } from '@/store/errorIndicator';
import { computed } from 'vue';

const errorIndicatorStore = useErrorIndicatorStore();

const activeIndicators = computed(() => {
  return errorIndicatorStore.activeIndicators;
});
</script>

<style scoped>
.error-pill {
  animation: float 2s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateX(-50%) translateY(0px);
  }
  50% {
    transform: translateX(-50%) translateY(-8px);
  }
}

/* Transition animations */
.error-indicator-enter-active,
.error-indicator-leave-active {
  transition: all 0.3s ease;
}

.error-indicator-enter-from {
  opacity: 0;
  transform: translateX(-50%) scale(0.8);
}

.error-indicator-leave-to {
  opacity: 0;
  transform: translateX(-50%) scale(0.8);
}

.error-indicator-move {
  transition: transform 0.3s ease;
}
</style>
